import { createMockSlugData } from '../../slug-data/mock';
import type { IndustrialType } from '../industrial-type';

/** Canonical mock {@link IndustrialType}. */
export const MOCK_INDUSTRIAL_TYPE: IndustrialType = {
  id: 1,
  name: 'Manufacturing',
  slug: 'manufacturing',
  industrial_subtypes: [
    createMockSlugData({ id: 11, name: 'CNC', slug: 'cnc' }),
    createMockSlugData({ id: 12, name: 'Welding', slug: 'welding' }),
  ],
};

/** Builds an {@link IndustrialType} from {@link MOCK_INDUSTRIAL_TYPE}. */
export function createMockIndustrialType(
  overrides?: Partial<IndustrialType>
): IndustrialType {
  return { ...MOCK_INDUSTRIAL_TYPE, ...overrides };
}

/** Builds a list of mock {@link IndustrialType} entries. */
export function createMockIndustrialTypeList(
  count = 3,
  overrideAt?: (index: number) => Partial<IndustrialType>
): IndustrialType[] {
  return Array.from({ length: count }, (_, i) =>
    createMockIndustrialType({
      id: i + 1,
      name: `Industry ${i + 1}`,
      slug: `industry-${i + 1}`,
      ...overrideAt?.(i),
    })
  );
}
